import React from "react";
import CongratulationsContainer from "components/containers/CongratulationsContainer/CongratulationsContainer";


function CongratulationsRoute(){
  return(
     <CongratulationsContainer/>
  )
}

export default CongratulationsRoute;
